import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { ButtonToolbar, Button, Panel, PageHeader } from 'react-bootstrap';
import { RangeQuestion } from '../questions/RangeQuestion.js';
import MultipleChoiceQuestion from '../questions/MultipleChoiceQuestion';
import MultipleAnswerQuestion from '../questions/MultipleAnswerQuestion';
import MultipleAnswerQuestionCombo from '../questions/MultipleAnswerComboQuestion/MultipleAnswerQuestionCombo';
import NumberQuestion from '../questions/NumberQuestion';
import WeightQuestion from '../questions/WeightQuestion/WeightQuestion';
import HeightQuestion from '../questions/HeightQuestion/HeightQuestion';
import TextQuestion from '../questions/TextQuestion';
import questionTypes from '../questions/questionTypes.json';
import styles from './Questionnaire.css'
import { YesNoQuestion } from '../questions/YesNoQuestion/YesNoQuestion';

let features = __features__;//eslint-disable-line
if (process.env.NODE_ENV === 'test') {
  features = {
    xToGo: true
  };
}
const showToComplete = features['xToGo'];//eslint-disable-line

Questionnaire.propTypes = {
  busy: PropTypes.bool.isRequired,
  incomplete: PropTypes.bool.isRequired,
  questions: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  units: PropTypes.array,
  onAnswer: PropTypes.func.isRequired,
  onUnitsChange: PropTypes.func,
  next: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  amountAnswered: PropTypes.number.isRequired,
  version: PropTypes.string.isRequired
};

const header = (allQuestions, version) => {
  return showToComplete ? <PageHeader>
  Questions <small>{allQuestions} to complete</small><small className={styles['float-right']}>{version}</small>
  </PageHeader> : <PageHeader>
  Questions <small className={styles['float-right']}>{version}</small>
  </PageHeader>
}

export function Questionnaire({
  busy,
  showValidation,
  incomplete,
  questions,
  answers,
  units,
  onAnswer,
  onUnitsChange,
  next,
  back,
  amountAnswered,
  version
}) {
  return (
    <div>
      {header(questions.length, version)}
      <Panel>
        <form
          onSubmit={event => {
            event.preventDefault();
            if (!busy && !incomplete) {
              next();
            }
          }}
        >
          {questions.map((question, index) => {
            const questionAnswers = answers.filter(answer => answer.questionId === question.questionId);
            let { type } = question

            if (question.options && question.options[0].meta && question.options[0].meta.measurementType === 'mass') {
              type = questionTypes.weight;
            } else if (question.options && question.options[0].meta && question.options[0].meta.measurementType === 'length') {
              type = questionTypes.height;
            }

            switch (type) {
            case questionTypes.range:
              return <RangeQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                options={question.options}
                onAnswer={onAnswer}
                answers={questionAnswers}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.multipleChoice:
              return <MultipleChoiceQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                options={question.options}
                onAnswer={onAnswer}
                answers={questionAnswers}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.multipleAnswer:
              return <MultipleAnswerQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                options={question.options}
                onAnswer={onAnswer}
                answers={questionAnswers}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.multipleAnswerCombo:
              return <MultipleAnswerQuestionCombo
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                options={question.options}
                onAnswer={onAnswer}
                answers={questionAnswers}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.number:
              return <NumberQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                onAnswer={onAnswer}
                options={question.options}
                answers={questionAnswers}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.weight:
              return <WeightQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                onAnswer={onAnswer}
                onUnitsChange={onUnitsChange}
                options={question.options}
                answers={questionAnswers}
                units={units}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.height:
              return <HeightQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                onAnswer={onAnswer}
                onUnitsChange={onUnitsChange}
                options={question.options}
                answers={questionAnswers}
                units={units}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.text:
              return <TextQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                onAnswer={onAnswer}
                options={question.options}
                answers={questionAnswers}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            case questionTypes.yesNo:
              return <YesNoQuestion
                key={question.questionId}
                questionId={question.questionId}
                text={question.text}
                options={question.options}
                onAnswer={onAnswer}
                answers={questionAnswers}
                showValidation={showValidation}
                validationState={question.validationState}
                help={question.help}
              />
            default:
              return <span key={index}>Invalid question Type</span>;
            }
          })}
        </form>
      </Panel>
      { showToComplete &&
        <div>
          <h2>
            <small>
              {amountAnswered}/{questions.length} Questions answered
            </small>
          </h2>
        </div>
      }
      <ButtonToolbar>
        <Button bsSize="large" onClick={back} disabled={busy}>
          {!busy && <FontAwesome name="arrow-left" />}
          {busy && <FontAwesome name="spinner" spin />}
          &nbsp;Back
        </Button>
        <Button bsStyle="primary" bsSize="large" onClick={next} disabled={busy}>
          Next&nbsp;
          {!busy && <FontAwesome name="arrow-right" />}
          {busy && <FontAwesome name="spinner" spin />}
        </Button>
      </ButtonToolbar>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/questionnaire/Questionnaire.js